import React from "react";

const Footer = () => {
  return (
    <footer className='bg-gray-800 text-white py-4 print:hidden'>
      <div className='container mx-auto px-4 sm:px-6 lg:px-8'>
        <p className='text-sm text-center'>© 2024 LetsCookTonight</p>
      </div>
    </footer>
  )
}

export default Footer;